/* eslint-disable camelcase */
import { ReactElement, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { slugify } from "@themuse/design-system";
import { useSearchState } from "hooks/SearchContext";
import { titleNormalization } from "utils/titleNormalization";
import { fetchJobTitleCities } from "utils/api";
import { JobTitleCities } from "interfaces/api/JobTitleList";
import getConfig from "next/config";
import styles from "./BrowseLinks.module.scss";
import { states } from "../../utils/constants";

/**
 * Convert a word to proper Case.
 */
const titleWordCase = (txt: string): string => `${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`;

const regex = /([~!@#$%^&*\]){}_+\-(\s])/ig;

/**
 * Convert a sentence to proper Case.
 */
const titleCase = (txt: string): string => txt.split(regex).map(titleWordCase).join("");

/**
 * Generates a link to the browse state page for this job title.
 *
 * @returns {ReactElement}.
 */
const BrowseLinks = (): ReactElement | null => {
    const router = useRouter();
    const { asPath } = router;
    const { publicRuntimeConfig: { museWebHost } } = getConfig();
    const { location: { userSelectedLocation }, keyword: { userInputValue } } = useSearchState();
    const [relatedCities, setRelatedCities] = useState([]);
    const keyword = slugify(titleNormalization(userInputValue)) || "";
    const state = slugify(userSelectedLocation.label || "").split("-").pop() ?? "";
    const titleCaseKeyWord = titleCase(keyword.split("-").join(" "));
    const stateName = states.find((x) => x[1] === state.toUpperCase())?.slice(0, 1) ?? "";

    useEffect(() => {
        fetchJobTitleCities(keyword, state.toUpperCase())
            .then((x: JobTitleCities) => setRelatedCities(x?.cities ?? []))
            .catch(console.error);
    }, [keyword, state]);
    const href = `${museWebHost}/browse/job-titles/${keyword}/${state.toUpperCase()}`;

    if (!asPath.includes("/hiring") || !relatedCities?.length) return null;

    return (
        <div className={styles.browserLinks}>
            <a href={href}>{`${titleCaseKeyWord} Jobs in ${stateName}`}</a>
        </div>

    );
};

BrowseLinks.displayName = "BrowseLinks";
export { BrowseLinks };
